import { useState } from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import { TypedDocumentNode } from '@graphql-typed-document-node/core'

import Sidepanel from 'modules/core/components/Sidepanel'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { Assignments } from 'modules/cost_centers/components/CostCenterAssigments/Assignments'

interface Props {
  loading?: boolean
  open: boolean
  resourceId: string
  resourceType: string
  title: string
  withAssignmentIdOpened?: string
  canManageAssignments?: boolean
  onClose: () => void
  onDelete?: () => void
  onSubmit?: () => void
  refetchQueries?: TypedDocumentNode[]
}

export const CostCenterAssignmentsSidepanel = ({
  loading,
  open,
  resourceId,
  resourceType,
  title,
  withAssignmentIdOpened,
  canManageAssignments = true,
  onClose,
  onDelete,
  onSubmit,
  refetchQueries,
}: Props) => {
  const [createNewAssignment, setCreateNewAssignment] = useState(false)
  const [showNewAssignmentButton, setShowNewAssignmentButton] = useState(true)
  const [isEditing, setIsEditing] = useState(false)
  const [hasEmptyState, setHasEmptyState] = useState(false)

  const addNewAssignment = () => {
    setCreateNewAssignment(true)
    setShowNewAssignmentButton(false)
    track(trackingEvents.accounting.newCostcenterAssignmentStarted)
  }

  const handleDelete = async () => {
    setCreateNewAssignment(false)
    onDelete?.()
  }

  const handleSubmit = async () => {
    setCreateNewAssignment(false)
    onSubmit?.()
  }

  const handleClose = () => {
    setCreateNewAssignment(false)
    setShowNewAssignmentButton(true)
    onClose()
  }

  const handleMutationCancel = () => {
    setCreateNewAssignment(false)
    setShowNewAssignmentButton(true)
  }

  // Hide footer when in empty state (new structure with no assignments)
  const seeFooter = canManageAssignments && !isEditing && showNewAssignmentButton && !hasEmptyState

  return (
    <Sidepanel
      overlay={false}
      width="wide"
      title={title}
      onClose={handleClose}
      open={open}
      footer={
        seeFooter && (
          <Button type="secondary" iconName="add" onClick={addNewAssignment}>
            {i18n.t('finance.cost_centers.assignments.new_assignment_card.title')}
          </Button>
        )
      }
      headerBorder
    >
      <Assignments
        resourceId={resourceId}
        resourceType={resourceType}
        withAssignmentIdOpened={withAssignmentIdOpened}
        canManageAssignments={canManageAssignments}
        skipQueries={!open}
        withNewAssignment={createNewAssignment}
        onEmptyAssignmentsCancel={handleClose}
        onMutationCancel={handleMutationCancel}
        onDelete={handleDelete}
        onSave={handleSubmit}
        onToggleEdit={setIsEditing}
        onShowEmptyState={setHasEmptyState}
        loading={loading}
        refetchQueries={refetchQueries}
      />
    </Sidepanel>
  )
}
